/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type HeartWrapper_viewer$ref = any;
export type HeartWrapperRefetchQueryVariables = {
    readonly selectedItemIds?: ReadonlyArray<string | null> | null;
    readonly loadPortfolioData: boolean;
    readonly userIds: ReadonlyArray<string | null>;
};
export type HeartWrapperRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": HeartWrapper_viewer$ref;
    } | null;
};
export type HeartWrapperRefetchQuery = {
    readonly response: HeartWrapperRefetchQueryResponse;
    readonly variables: HeartWrapperRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "selectedItemIds",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "Literal",
        "name": "portfolioTypes",
        "value": [
            "HEART"
        ]
    } as any), v4 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        } as any),
        (v2 /*: any*/)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "HeartWrapperRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "HeartWrapper_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "loadPortfolioData",
                                    "variableName": "loadPortfolioData"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "selectedItemIds",
                                    "variableName": "selectedItemIds"
                                },
                                (v1 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "HeartWrapperRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "loadPortfolioData",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "heartItemMatches",
                                    "name": "portfolioItemMatches",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "itemIds",
                                            "variableName": "selectedItemIds"
                                        },
                                        (v3 /*: any*/),
                                        (v1 /*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemV2",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioItemId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": (v4 /*: any*/)
                                        },
                                        (v2 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "userPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        (v3 /*: any*/),
                                        (v1 /*: any*/)
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": (v4 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "HeartWrapperRefetchQuery",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/HeartWrapperRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '3466aa7e4670ced0831bac583dd8102c';
export default node;
